import angular from "angular";

angular
    .module('app')
    .component('courseBuyConfirm', {
        template: require('./course-buy-confirm.html'),
        controller: ['$http', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http) {

    let $ctrl = this;

    $ctrl.selectedTab = null;
    $ctrl.ope = null;
    $ctrl.ofe = null;

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;
        $ctrl.type = $ctrl.resolve.type;
        $ctrl.group = $ctrl.resolve.group;
        if ($ctrl.type === 'individual') {
            $ctrl.selectedTab = $ctrl.course.online_payment ? 'online' : 'offline';
            $ctrl.ope = $ctrl.course.online_payment;
            $ctrl.ofe = $ctrl.course.offline_payment;
        } else {
            $ctrl.selectedTab = $ctrl.resolve.group.online_payment ? 'online' : 'offline';
            $ctrl.ope = $ctrl.group.online_payment;
            $ctrl.ofe = $ctrl.group.offline_payment;
        }
    };

    $ctrl.buy = function () {
        $ctrl.loading = true;
        $http
            .post(`/courses/${$ctrl.course.id}/buy`, {
                type: $ctrl.type,
                group_id: $ctrl.group ? $ctrl.group.id : null,
            })
            .then(
                function (response) {
                    let id = response.data.payment_id;
                    window.location = `/payments/${id}/redirect`;
                },
                function (error) {
                    $ctrl.loading = false;
                }
            );
    };

}
